import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core'

/** Registration key for this renderer in each grid's `components` map. */
export const commentCountRendererKey = 'commentCountRenderer'

/** DLITE-5094: icon and tooltip for an account whose commentary is unreadable. */
export const COMMENT_UNAVAILABLE_ICON = 'mdi-comment-off-outline'
export const COMMENT_UNAVAILABLE_TITLE =
  'Commentary unavailable for this account'

/**
 * AG Grid cell renderer for the "Comments" column.
 * Plain JS class (not Angular) — AG Grid manages lifecycle via ICellRenderer.
 */
export class CommentCountCellRenderer implements ICellRenderer {
  private eGui!: HTMLElement
  // For rows whose count is a presence flag rather than a real total.
  private hideBadge = false

  init(params: ICellRendererParams): void {
    this.eGui = document.createElement('div')
    this.eGui.classList.add('comment-count-cell')
    this.hideBadge = !!params.colDef?.cellRendererParams?.hideBadge
    this.render(params.value as number | null | undefined)
  }

  refresh(params: ICellRendererParams): boolean {
    this.hideBadge = !!params.colDef?.cellRendererParams?.hideBadge
    this.render(params.value as number | null | undefined)
    return true
  }

  getGui(): HTMLElement {
    return this.eGui
  }

  private render(count: number | null | undefined): void {
    this.eGui.innerHTML = ''
    this.eGui.removeAttribute('title')

    // DLITE-5094: the column's valueGetter yields null for an account whose
    // commentary the user cannot read.
    if (count === null) {
      const off = document.createElement('i')
      off.classList.add('mdi', COMMENT_UNAVAILABLE_ICON)
      this.eGui.title = COMMENT_UNAVAILABLE_TITLE
      this.eGui.appendChild(off)
      return
    }

    const icon = document.createElement('i')
    icon.classList.add(
      'mdi',
      count && count > 0 ? 'mdi-comment' : 'mdi-comment-outline',
    )
    this.eGui.appendChild(icon)

    if (!this.hideBadge && count && count > 0) {
      const badge = document.createElement('span')
      badge.classList.add('comment-badge')
      badge.textContent = count.toString()
      this.eGui.appendChild(badge)
    }
  }
}
